import {
  EntityList,
  EntityListProps,
  renderInvertedYesNoIcon,
} from 'components/EntityList'
import { Material } from 'gql.generated'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type MaterialListProps = EntityListProps<Material>

export const MaterialList: React.FunctionComponent<MaterialListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('inactive', {
        minWidth: 40,
        maxWidth: 40,
        name: t('field.active.label'),
        onRender: renderInvertedYesNoIcon,
        ungroupable: true,
      }),
      fieldColumn('containerType', {
        minWidth: 100,
        ungroupable: true,
      }),
      fieldColumn('label', {
        minWidth: 150,
        ungroupable: true,
      }),
      fieldColumn('nettoWeight', { minWidth: 100, ungroupable: true }),
      fieldColumn('length', { ungroupable: true }),
      fieldColumn('width', { ungroupable: true }),
      fieldColumn('height', { ungroupable: true }),
    ],
    [fieldColumn]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
